import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeviceMaintenanceRoutingModule } from './device-maintenance-routing.module';
import { DeviceMaintenanceComponent } from './device-maintenance.component';
import { DeviceMaintenanceFormComponent } from './device-maintenance-form/device-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { DeviceMaintenanceFilterComponent } from './device-maintenance-filter/device-maintenance-filter.component';
import { BranchDropdownModule } from 'src/app/core/custom-modules/dropdowns/branch-dropdown/branch-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    DeviceMaintenanceRoutingModule,
    BranchDropdownModule
  ],
  declarations: [DeviceMaintenanceComponent, DeviceMaintenanceFormComponent, DeviceMaintenanceFilterComponent],
  entryComponents: [DeviceMaintenanceFilterComponent]
})
export class DeviceMaintenanceModule { }
